import { NativeStackScreenProps } from '@react-navigation/native-stack';

export interface UpdateCardKycModalProps {
  onLayout: (event: any) => void;
}

export enum UpdateCardKycStackRoutes {
  Individual = 'individual',
  Placed = 'placed',
}

export type UpdateCardKycStackParamList = {
  [UpdateCardKycStackRoutes.Individual]: UpdateCardKycModalProps & {
    data: any;
    onData: (data: any) => void;
    func?: (data: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
    onChangeView?: () => void;
    onBackData: (data: any) => void;
    initData: any;
    compareData: any;
  };
  [UpdateCardKycStackRoutes.Placed]: UpdateCardKycModalProps & {
    data?: any;
    returnData?: any;
    refresh?: () => void;
  };
};

export type UpdateCardKycStackScreenProps<Screen extends keyof UpdateCardKycStackParamList> = NativeStackScreenProps<
  UpdateCardKycStackParamList,
  Screen
>;
